var _classCallCheck = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var Base = require('./base');
var SuperagentService = /*#__PURE__*/function (_Base) {
  "use strict";

  _inherits(SuperagentService, _Base);
  var _super = _createSuper(SuperagentService);
  function SuperagentService() {
    _classCallCheck(this, SuperagentService);
    return _super.apply(this, arguments);
  }
  _createClass(SuperagentService, [{
    key: "request",
    value: function request(options, params) {
      var superagent = this.connection(options.method, options.url).set(this.options.headers || {}).set('Accept', 'application/json').set(params.connection || {}).set(options.headers || {}).type(options.type || 'json');
      return new Promise(function (resolve, reject) {
        superagent.set(options.headers);
        if (options.body) {
          superagent.send(options.body);
        }
        superagent.end(function (error, res) {
          if (error) {
            try {
              var response = error.response;
              error = JSON.parse(error.response.text);
              error.response = response;
            } catch (e) {}
            return reject(error);
          }
          resolve(res && res.body);
        });
      });
    }
  }]);
  return SuperagentService;
}(Base);
module.exports = SuperagentService;